import { render, staticRenderFns } from "./HistoryV2.vue?vue&type=template&id=45058b7b&scoped=true"
import script from "./HistoryV2.vue?vue&type=script&lang=js"
export * from "./HistoryV2.vue?vue&type=script&lang=js"
import style0 from "./HistoryV2.vue?vue&type=style&index=0&id=45058b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45058b7b",
  null
  
)

export default component.exports